import React from 'react';

import { BaseIconProps } from '../interfaces';

const PantryTagIcon: React.FC<BaseIconProps> = ({ color, height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    zoomAndPan="magnify"
    viewBox="0 0 375 374.999991"
    height={height}
    preserveAspectRatio="xMidYMid meet"
    version="1.0"
  >
    <defs>
      <clipPath id="6593e0ed84">
        <path
          d="M 37.710938 0 L 333.960938 0 L 333.960938 375 L 37.710938 375 Z M 37.710938 0 "
          clipRule="nonzero"
        />
      </clipPath>
      <clipPath id="f22556a057">
        <path
          d="M 40.730469 364.183594 L 331.226562 364.183594 L 331.226562 375 L 40.730469 375 Z M 40.730469 364.183594 "
          clipRule="nonzero"
        />
      </clipPath>
    </defs>
    <rect
      x="-37.5"
      width="450"
      fill="#ffffff"
      y="-37.499999"
      height="449.999989"
      fillOpacity="1"
    />
    <rect
      x="-37.5"
      width="450"
      fill="#ffffff"
      y="-37.499999"
      height="449.999989"
      fillOpacity="1"
    />
    <g clipPath="url(#6593e0ed84)">
      <path
        fill={color}
        d="M 333.761719 134.730469 C 331.6875 122.050781 326.757812 109.882812 319.472656 99.503906 C 315.214844 93.390625 310.117188 87.835938 304.402344 83.015625 C 302.777344 81.667969 301.878906 79.703125 301.878906 77.628906 L 301.878906 69.609375 C 309.277344 67.589844 314.765625 60.746094 314.765625 52.667969 C 314.765625 47.84375 312.804688 43.414062 309.613281 40.273438 C 306.417969 37.074219 302.046875 35.113281 297.230469 35.113281 C 306.921875 35.113281 314.765625 27.261719 314.765625 17.554688 C 314.765625 12.675781 312.804688 8.300781 309.613281 5.160156 C 306.417969 1.964844 301.992188 0 297.171875 0 L 74.441406 0 C 69.625 0 65.253906 1.964844 62.058594 5.160156 C 58.863281 8.359375 56.902344 12.734375 56.902344 17.554688 C 56.902344 27.261719 64.75 35.113281 74.441406 35.113281 C 69.625 35.113281 65.195312 37.074219 62.058594 40.273438 C 58.863281 43.46875 56.902344 47.84375 56.902344 52.667969 C 56.902344 60.746094 62.339844 67.53125 69.792969 69.609375 L 69.792969 77.628906 C 69.792969 79.703125 68.839844 81.667969 67.269531 83.015625 C 61.5 87.835938 56.457031 93.390625 52.195312 99.503906 C 44.96875 109.882812 40.039062 122.109375 37.910156 134.730469 L 37.796875 135.175781 L 37.796875 372.328125 C 37.796875 417.648438 74.609375 454.5 119.886719 454.5 L 251.785156 454.5 C 297.0625 454.5 333.875 417.648438 333.875 372.328125 L 333.875 135.175781 Z M 322.21875 372.382812 C 322.21875 411.253906 290.617188 442.890625 251.785156 442.890625 L 119.886719 442.890625 C 81.054688 442.890625 49.453125 411.253906 49.453125 372.382812 L 49.453125 136.1875 C 51.300781 125.417969 55.558594 115.042969 61.722656 106.179688 C 65.421875 100.90625 69.792969 96.082031 74.777344 91.933594 C 79.035156 88.398438 81.503906 83.183594 81.503906 77.628906 L 81.503906 70.28125 L 290.28125 70.28125 L 290.28125 77.628906 C 290.28125 83.125 292.746094 88.34375 297.003906 91.933594 C 301.933594 96.082031 306.363281 100.90625 310.058594 106.179688 C 316.222656 115.042969 320.480469 125.417969 322.332031 136.1875 L 322.332031 372.382812 Z M 322.21875 372.382812 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </g>
    <path
      fill={color}
      d="M 241.332031 169.398438 C 144.300781 190.960938 121.660156 257.480469 99.234375 313.21875 L 119.613281 320.335938 L 129.855469 295.539062 C 135.03125 297.371094 140.421875 298.773438 144.300781 298.773438 C 262.894531 298.773438 295.238281 115.492188 295.238281 115.492188 C 284.457031 137.054688 208.988281 139.75 155.082031 150.53125 C 101.175781 161.3125 79.613281 207.132812 79.613281 228.695312 C 79.613281 250.257812 98.480469 269.125 98.480469 269.125 C 133.519531 169.398438 241.332031 169.398438 241.332031 169.398438 Z M 241.332031 169.398438 "
      fillOpacity="1"
      fillRule="nonzero"
    />
    <g clipPath="url(#f22556a057)">
      <path
        fill={color}
        d="M 331.226562 364.183594 L 331.226562 377.25 L 40.746094 377.25 L 40.746094 364.183594 Z M 331.226562 364.183594 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default PantryTagIcon;
